import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import Navbar from 'react-bootstrap/cjs/Navbar';
import styles from './buildsHeader.module.sass';
import { BuildTypeFilter } from '../buildFilter/buildTypeFilterSelector';
import BuildIdSearchInput from './buildSearch/buildIdSearchInput';
import { YoProjectMenu, YoUserMenu } from '@yakoffice/shared-components';
import { useYoConfigSnapshots, useYoProjectsSnapshots, YoAuthUser } from '@yakoffice/yakoffice-firebase';
import { hostedOnYakOfficeAppUrl } from '@yakoffice/helpers';

interface PropsType {
  buildIdSearchVisibility: boolean;
  toggleSearchVisibility: () => void;
  currentBuildTypeFilter: BuildTypeFilter;
  updateBuildTypeFilter: (newBuildsLimit: BuildTypeFilter) => void;
  buildIdSearchVal: string;
  searchOnBuildId: (buildId: string) => void;
  disabled: boolean;
  isMobile: boolean;
  authUser: YoAuthUser;
}


const BuildsHeader: FC<PropsType> = observer((props) => {

  const { yoConfig } = useYoConfigSnapshots();
  const { yoProjects } = useYoProjectsSnapshots();

  return (
    <Navbar className={styles.navbar}>
      <>
        <YoProjectMenu authUser={props.authUser} yoProjects={yoProjects} toolId={'builds'}
                       isDevSite={hostedOnYakOfficeAppUrl(window.location.hostname)} hideText={true} />

        <BuildIdSearchInput currentBuildId={props.buildIdSearchVal} searchOnBuildId={props.searchOnBuildId}
                            searchVisibility={props.buildIdSearchVisibility}
                            toggleSearchVisibility={props.toggleSearchVisibility} />

        {yoConfig && <YoUserMenu authUser={props.authUser}
                                 portalUsersRoute={yoConfig.portalUsersRoute}
                                 portalUrl={yoConfig.portalUrl}
                                 hostedInPortal={false} />
        }
      </>
    </Navbar>
  );
});

export default BuildsHeader;
